var map = {
	"./de/mecha-active-btn.png": "5n15",
	"./en/mecha-active-btn.png": "hXM5",
	"./es/mecha-active-btn.png": "2e3u",
	"./fr/mecha-active-btn.png": "Bd0p",
	"./ja/mecha-active-btn.png": "OXYA",
	"./ko/mecha-active-btn.png": "ooWA",
	"./pt/mecha-active-btn.png": "to4c",
	"./ru/mecha-active-btn.png": "Qs1B",
	"./tc/mecha-active-btn.png": "tX56",
	"./th/mecha-active-btn.png": "vdgq"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iVCV";